import { Loader } from "@googlemaps/js-api-loader"
import { getRexDocuments } from './custom-functions.js'

async function initMap() {

	const loader = new Loader({
		apiKey: "AIzaSyA7OpqsOyv1YChC_TxY-oKCvOTBvscJrMw",
		version: "weekly"
	});

	const options = {
		componentRestrictions: {
			country: "au"
		},
		fields: ["address_components", "geometry", "icon", "name"],
		strictBounds: false,
		types: ["address"],
	};

	loader.load().then(async () => {
		const { Autocomplete } = await google.maps.importLibrary("places");

		const autocompleteInputs = document.querySelectorAll('.autocomplete-address input[type="text"]');
		autocompleteInputs.forEach( function(input) {
			new Autocomplete(input, options);
		});
	});

}

/**
 * Show the appraisal banner if the cookie is not set.
 */
function showAppraisalBanner() {

	const alertBox = document.getElementById('appraisal-banner');
	const alert = understrap.Alert.getOrCreateInstance(alertBox);
	let checkCookie = document.cookie.indexOf("CookieBy=imagePropertyAppraisalBanner");

	if ( checkCookie != -1 ) {
		alert.close();
	} else {
		if( alertBox ){
			alertBox.classList.add('show');
			alertBox.classList.remove('hide');
		}
		
	}

	if( alertBox ) {
		// Set cookie when alert closed so we don't show it again.
		alertBox.addEventListener('closed.bs.alert', event => {
			// Set the cookie on close.
			if ( checkCookie == -1 ) {
				document.cookie = "CookieBy=imagePropertyAppraisalBanner; max-age=" + 60 * 60 * 24;
			}
		});
	}
}

document.addEventListener("DOMContentLoaded", function(event) { 
	initMap();
	showAppraisalBanner();
	updateSelectFields();
});

function updateSelectFields() {

	const e = document.getElementsByTagName("select");

	for (var i = 0; i < e.length; i++) {
		if ( ! e[i].classList.contains('searchable') ) {
			NiceSelect.bind(e[i]);
		}
	}
}

/**
 * Prevent the search form from submitting when the search field is focused.
 * Allows users to select from the dropdown without submitting the form.
 */
function propertySearchForm() {

	NiceSelect.bind(
		document.getElementById('property_location'),
		{searchable: true, placeholder: 'Search'}
	);

	const searchForm = document.getElementById('property-search-form');

	searchForm.addEventListener('submit', function(e) {
		if ( searchForm.querySelector('.nice-select-search:focus') ) {
			e.preventDefault();
			document.getElementById("PrimarySubmit").focus();
		}
	});
}


function commissionCalculator() {

	$ = jQuery;
	var format = function(num) {
		var str = num.toString().replace("$", ""), parts = false, output = [], i = 1, formatted = null;
		if(str.indexOf(".") > 0) {
			parts = str.split(".");
			str = parts[0];
		}
		str = str.split("").reverse();
		for(var j = 0, len = str.length; j < len; j++) {
			if(str[j] != ",") {
				output.push(str[j]);
				if(i%3 == 0 && j < (len - 1)) {
					output.push(",");
				}
				i++;
			}
		}
		formatted = output.reverse().join("");
		return("$" + formatted + ((parts) ? "." + parts[1].substr(0, 2) : ""));
	};

	/**
	 * Calculate based on commission calculator spreadsheet provided by Image Property.
	 * Calculate the Commission Brackets:
	 * * 70% for every dollar under $100k (gci_70).
	 * 80% for every dollar between $100k - $200k (gci_80).
	 * 100% commission for every dollar above $200k.
	 */

	const cgi = document.getElementById("total_gci_per_annum");
	const sales_per_annum = document.getElementById("sales_per_annum");
	const gross_commission = document.getElementById("gross_commission");
	const sub_fee = document.getElementById("Sub_fee");
	const collapseExample = document.getElementById("collapseExample");
	const calculateButton = document.getElementById("calculate");
	const settlement_fee = document.getElementById("settlement_fee");
	const total_commission = document.getElementById("total_commission");
	const resetButton = document.getElementById("show");
	
	let gci_70 = 0;
	let gci_80 = 0;
	let gci_100 = 0;

	resetButton.addEventListener("click", function() {
		calculateButton.style.display ="";
	});
	
	calculateButton.addEventListener("click", function() {
		calculateButton.style.display = "none";
		if ( cgi.value >= 100000 ) { 
			gci_70 = 70000; 
		} else {  
			gci_70 = cgi.value * .7; 
		}

        if ( cgi.value >= 100000 && cgi.value <= 200000 ) { 
			gci_80 = (cgi - 100000 ) * .8;
		} else if (cgi.value >= 200000 ) { 
			gci_80 = 80000; 
		} 

        if ( cgi.value >= 200000 ) {  
			gci_100 = cgi.value - 200000; 
		} else {
			gci_100 = (cgi.value - 200000 ) * .8; 
			
			if (gci_100 <= 0 ) { 
				gci_100 = 0; 
			} 
		}

		let gross = gci_70 + gci_80 + gci_100;
		let total_sub_fee = 395 * 12;
		let settlement = 649 * sales_per_annum.value;
		let net_commission =  parseInt(gross) - ( parseInt(settlement) + parseInt(total_sub_fee) );

        gross_commission.value = gross;
		sub_fee.value = total_sub_fee;
		settlement_fee.value = settlement;
		total_commission.innerHTML = format(net_commission);
		collapseExample.classList.add("show");

	});
}

// Add your custom JS here.

// MAXIMISE the homepage video and set it's size to huge!
// min-width:
// height:

const homepageVideoBackgroundIframe = document.getElementById('homepage-bg');
const homepageVideoBackgroundContainer = document.querySelector('.bg-video');

if( homepageVideoBackgroundIframe && homepageVideoBackgroundContainer ){

    // check if the current ration fits or needs to extend horizontally
    const ratio = 16 / 9;

    const windowRatio = window.innerWidth / window.innerHeight;

    if( windowRatio >= ratio ){
        // NORMAL RATIO
        homepageVideoBackgroundContainer.style.minWidth = window.innerWidth + "px";
        homepageVideoBackgroundContainer.style.height = window.innerHeight + "px";

    } else {
        // SOME OTHER RATIO
        homepageVideoBackgroundContainer.style.minWidth = ( window.innerHeight * ratio ) + "px";
        homepageVideoBackgroundContainer.style.height = window.innerHeight + "px";

    }

    homepageVideoBackgroundIframe.onload = ( e ) => {
        e.target.classList.add('iframe-loaded');
    }

}
(function ($) {
    $('.player-btn').on('click', function () {
        var btn = this;
        var video_src = $(btn).data('src');
        var video_title = $(btn).data('title');
        $('#VideoModal #videoModalLabel').html(video_title);
        $('#VideoModal .modal-body .ratio').html(
            '<iframe width="100%" height="720" src="' + video_src + '" title="' + video_title + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
        );

    });

    $('#VideoModal').on('hide.bs.modal', function (event) {
        $('#VideoModal #videoModalLabel').html('');
        $('#VideoModal .modal-body .ratio iframe').remove();
    });
})(jQuery);

/**
 * On page load, trigger the document fetch on the dropdown.
 */
document.addEventListener( 'DOMContentLoaded', function ( event ) {

	const documentLinks = document.getElementById( 'contract-links' )

	if ( documentLinks ) {
		documentLinks.addEventListener( 'show.bs.dropdown', event => {
			getRexDocuments( documentLinks.dataset.id )
		} );
	}

} )

export { propertySearchForm, commissionCalculator }